// extracted by mini-css-extract-plugin
export default {"Industry":"industry_Industry__Y6+NS"};